import LinkedPromiseList from './LinkedPromiseList.js';
import eth from 'decentralized/ethereum.js';

const MIN_DATE = new Date(2018, 7, 3);
const DAYS = 40;
const BLOCKS = 3000000;
const MIN_BLOCK = 3000000;
      
class GetSequences {
    constructor(ethereum=eth, includePrivate=true) {
        this.ethereum = ethereum;
        this.linkedPromiseList= undefined;
        this.results = [];
        this.includePrivate = includePrivate;
    }

    async executeQuery(user) {
        let block = 7000000;
        if (navigator.onLine) {
            block = await this.getCurrentBlock();
        }
        this.linkedPromiseList = await this.start(user, block - BLOCKS, block);
        return this;
    }

    async getNext() {
        if (this.linkedPromiseList === undefined || this.canceled) {
            return undefined;
        }
        let results = await this.linkedPromiseList.getCurrent();
        results = Array.from(new Set(results));

        this.results = this.results.concat(results);
        this.results = this.sort(this.results);

        if (this.linkedPromiseList === undefined) {
            return undefined;
        }

        this.linkedPromiseList = await this.linkedPromiseList.getNext();

        return this.linkedPromiseList;
    }

    async start(user, fromBlock, toBlock) {
        if (fromBlock <= MIN_BLOCK) {
            return new Promise((resolve, reject) => resolve(undefined));
        }
        console.log('Get Sequences start fromBlock=%s toBlock=%s', fromBlock, toBlock);
        let tokenizedSequences = this.ethereum.tokenizedSequences;
        return new LinkedPromiseList(
            async () => (
                await tokenizedSequences.getSequences(user, fromBlock, toBlock)),
            new LinkedPromiseList(
                async () => 
                    (await this.ethereum.getNewSequences(user, fromBlock, toBlock)), //.concat(
                        //await this.ethereum.getOldSequences(user, fromBlock, toBlock)),
                    this.start(user, fromBlock - BLOCKS, toBlock - BLOCKS)));
    }

    sort(ret) {
        ret.sort((a,b) => b.blockNumber - a.blockNumber);
        return ret;
    }

    async getCurrentBlock() {
        return await this.ethereum.web3.eth.getBlockNumber();
    }
}

export default GetSequences;
